<template>
    <div class="question" :class="'question-'+index">
        <template v-if="!result">
            <div class="question__number"><span v-html="$t('QUIZ_QUESTION')">Question</span> {{index}}</div>
            <div class="question__description" v-if="type == 'gap'" v-html="$t('QUIZ_QUESTION_INFO01')">Click into the empty fields to choose an answer</div>
            <div class="question__description" v-else-if="type == 'multiple'">
                <span v-if="!questionInfo" v-html="$t('QUIZ_QUESTION_INFO02')">Select one or more answer</span>
                <span else-if>{{questionInfo}}</span>
            </div>
            <template v-if="type == 'gap'">
                <GapText :answers="answers" :index="index" :key="componentKey">
                    <template slot="text" >
                        <div v-html="question"></div>
                    </template>
                </GapText>
            </template>
            <div class="question__text" v-else-if="type == 'multiple'">
                <slot name="question-text"></slot>
                    <MultipleChoice :answers="answers" :index="index">
                        <template slot="text" >
                            <div v-html="question"></div>
                        </template>
                    </MultipleChoice>
            </div>
        </template>
       <!-- <template v-else>
            <template v-if="showAnswers == false">
                <div class="success" v-if="resultStatus == 1">
                    <div class="no__attempts-left">
                        <h2>Congratulations,</h2>
                        <p>you have succeded in the quiz, you have won a special souvenir: <br>
                            <span class="my-4 d-flex align-items-center">
                            <span v-if="worldName == 1">
                                <img src="@/assets/global/souvenir_01.png" class="img-fluid">
                            </span>
                            <span v-else-if="worldName == 2">
                                <img src="@/assets/global/souvenir_02.png" class="img-fluid">
                            </span>
                            <span v-else-if="worldName == 3">
                                <img src="@/assets/global/souvenir_03.png" class="img-fluid">
                            </span>
                        </span>
                            Do you want to explore the next world or do you want to stay a little longer in
                            <span v-if="worldName == 1">
                           Ginza?
                        </span>
                            <span v-else-if="worldName == 2">
                            Ueno Park?
                        </span>
                            <span v-else-if="worldName == 3">
                            Asakusa?
                        </span>
                        </p>
                    </div>
                </div>
                <div class="failed" v-else-if="resultStatus == 0">
                    <div class="no__attempts-left" v-if="attemptsLeft == 0">
                        <p>Unfortunatley you didnt reach enough points
                            to qualify for a Tokyo -souvenir this time, but you did win one Discovery PIN. Click on the button to see the correct answers</p>
                    </div>
                    <div class="no__attempts-left" v-if="attemptsLeft == 1">
                        <p>Sorry you didn’t manage to reach 4/5 points<br> you still got 1 more attempt left, please try again to get one Discovery PIN and one special souvenir from your trip.
                            If you need, exit the quiz and discover the product information contained in this world again to pass the quiz</p>
                    </div>
                    <div class="no__attempts-left" v-if="attemptsLeft == 2">
                        <p>Sorry you didn’t manage to reach 4/5 points<br> you still got 2 more attempt left, please try again to get one Discovery PIN and one special souvenir from your trip.
                            If you need, exit the quiz and discover the product information contained in this world again to pass the quiz</p>
                    </div>
                </div>
            </template>
          <template v-if="showAnswers == true">
              <div class="failed">
                  <div class="no__attempts-left">
                      <p>Unfortunatley you didnt reach enough points
                          to qualify for a Tokyo -souvenir this time, but you did win one Discovery PIN. Click on the button to see the correct answers</p>
                  </div>
              </div>
          </template>

        </template>-->

    </div>
</template>

<script>

    import GapText from "@/components/questionType/GapText";
    import MultipleChoice from "@/components/questionType/MultipleChoice";
    import $ from "jquery";
    export default {
        name: "Question",
        components: {MultipleChoice, GapText},
        props: {
            type: String,
            index: Number,
            question: String,
            questionInfo: String,
            answers: Array,
            result: Boolean,
            resultStatus: Number,
            attemptsLeft: Number,
            worldName: Number,
            showAnswers: Boolean,
        },
        data() {
            return {
                componentKey: 0,
            };
        },
        comments:{
            GapText,
            MultipleChoice
        },
        mounted() {

        },
        methods: {

        },
        watch: {
            question: {
                handler(val){
                    this.componentKey += 1;
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>